"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIPopoverHeader = _interopRequireDefault(require("./UIPopoverHeader"));

var _UIPopoverBody = _interopRequireDefault(require("./UIPopoverBody"));

var _UIPopoverFooter = _interopRequireDefault(require("./UIPopoverFooter"));

var _UIPopoverArrow = _interopRequireDefault(require("./UIPopoverArrow"));

var _PlacementConstants = require("./PlacementConstants");

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

var _times = require("HubStyleTokens/times");

var _Functions = require("../core/Functions");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _Use = require("./utils/Use");

var PopoverContext = _interopRequireWildcard(require("../context/PopoverContext"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition-property: ", ";\n  transition-duration: ", "ms;\n  opacity: ", ";\n  transform: ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isReactNode = function isReactNode(node) {
  return (0, _typeof2.default)(node) !== 'object' || _react.default.isValidElement(node) || Array.isArray(node);
};

var transitionDuration = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var getPopoverClassName = function getPopoverClassName(className, use) {
  return (0, _classNames.default)(className, _Use.USE_CLASSES[use], 'private-popover', 'uiPopover');
};

var getStyle = function getStyle(style, width) {
  return width ? (0, _extends2.default)({
    maxWidth: width,
    width: width
  }, style) : style;
};

var getContext = function getContext(use) {
  return {
    use: use
  };
};

var renderArrow = function renderArrow(_ref) {
  var arrowColor = _ref.arrowColor,
      arrowSize = _ref.arrowSize,
      placement = _ref.placement,
      use = _ref.use;
  var computedArrowParams = _UIPopoverArrow.default.ARROW_SIZES[arrowSize];
  return _react.default.createElement(_UIPopoverArrow.default, {
    color: arrowColor,
    inset: computedArrowParams.inset,
    key: "arrow",
    placement: placement,
    width: computedArrowParams.width,
    popoverUse: use
  });
};

var renderStructuredContent = function renderStructuredContent(content, onOpenChange, showCloseButton) {
  var header = content.header,
      body = content.body,
      footer = content.footer,
      step = content.step;
  return [header && _react.default.createElement(_UIPopoverHeader.default, {
    key: "header",
    showCloseButton: showCloseButton,
    onOpenChange: onOpenChange
  }, header), body && _react.default.createElement(_UIPopoverBody.default, {
    key: "body"
  }, body), (footer || step) && _react.default.createElement(_UIPopoverFooter.default, {
    key: "footer",
    hasStructuredFooter: !!footer,
    hasStep: !!step
  }, step, footer)];
};

var renderContentWithArrow = function renderContentWithArrow(Content, content, arrowProps, onOpenChange, showCloseButton) {
  var renderedContent = Content ? _react.default.createElement(Content, null) : content;
  /**
   * Throw a warning on:
   * - Content or content that is a node
   * - content is an object that doesn't have a `header`
   */

  if (showCloseButton && (isReactNode(renderedContent) || !renderedContent.header)) {
    _devLogger.default.warn({
      message: "UIPopover: `showCloseButton={true}` requires you to provide the `content` prop as an object with a `header`.",
      key: "UIPopover: showCloseButton"
    });
  }

  var arrow = renderArrow(arrowProps);

  if (isReactNode(renderedContent)) {
    return [arrow, _react.default.createElement("div", {
      className: "private-popover__inner",
      key: "content"
    }, renderedContent)];
  }

  return [arrow, _react.default.createElement("div", {
    className: "private-popover__inner",
    key: "content"
  }, renderStructuredContent(renderedContent, onOpenChange, showCloseButton))];
};

var transformOriginMixin = (0, _styledComponents.css)(_templateObject(), ['top', 'bottom', 'left', 'right'].map(function (side) {
  return ".tether-element-attached-" + side + " & { transform-origin: " + side + " }";
}), ['top', 'bottom'].map(function (ySide) {
  return ['left', 'right'].map(function (xSide) {
    return ".tether-element-attached-" + ySide + ".tether-element-attached-" + xSide + " & { transform-origin: " + ySide + " " + xSide + " }";
  });
}));
var PopoverTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "UIPopoverContent__PopoverTransitionWrapper",
  componentId: "sc-1574ccz-0"
})(_templateObject2(), function (_ref2) {
  var transitioning = _ref2.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref3) {
  var duration = _ref3.duration;
  return duration;
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? '0' : '1';
}, function (_ref5) {
  var hidden = _ref5.hidden,
      transitioning = _ref5.transitioning;
  if (!hidden && !transitioning) return 'none';
  /* IE bugfix: #5368 */

  return hidden ? 'scale(.75)' : 'scale(1)';
}, transformOriginMixin);

var UIPopoverContent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIPopoverContent, _React$Component);

  function UIPopoverContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIPopoverContent);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIPopoverContent).call(this, props));
    _this.state = {
      openComplete: props.open && !props.animateOnMount
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._getContext = (0, _memoizeOne.default)(getContext);
    _this.handleOpenComplete = _this.handleOpenComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseStart = _this.handleCloseStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIPopoverContent, [{
    key: "handleOpenComplete",
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;
      this.setState({
        openComplete: true
      });
      (0, _Functions.callIfPossible)(onOpenComplete);
    }
  }, {
    key: "handleCloseStart",
    value: function handleCloseStart() {
      var onCloseStart = this.props.onCloseStart;
      this.setState({
        openComplete: false
      });
      (0, _Functions.callIfPossible)(onCloseStart);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var onOpenChange = this.props.onOpenChange;
      if (evt.key === 'Escape') onOpenChange((0, _SyntheticEvent.default)(false));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animateOnMount = _this$props.animateOnMount,
          animateOnToggle = _this$props.animateOnToggle,
          arrowColor = _this$props.arrowColor,
          arrowSize = _this$props.arrowSize,
          className = _this$props.className,
          content = _this$props.content,
          Content = _this$props.Content,
          onCloseComplete = _this$props.onCloseComplete,
          __onCloseStart = _this$props.onCloseStart,
          __onOpenComplete = _this$props.onOpenComplete,
          onOpenStart = _this$props.onOpenStart,
          open = _this$props.open,
          placement = _this$props.placement,
          style = _this$props.style,
          use = _this$props.use,
          showCloseButton = _this$props.showCloseButton,
          onOpenChange = _this$props.onOpenChange,
          width = _this$props.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["animateOnMount", "animateOnToggle", "arrowColor", "arrowSize", "className", "content", "Content", "onCloseComplete", "onCloseStart", "onOpenComplete", "onOpenStart", "open", "placement", "style", "use", "showCloseButton", "onOpenChange", "width"]);
      var openComplete = this.state.openComplete;
      var computedOpen = open && (Content || content);
      var renderedContent = computedOpen ? _react.default.createElement(PopoverContext.Provider, {
        value: this._getContext(use)
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: getPopoverClassName(className, use),
        "data-open-complete": openComplete,
        onKeyDown: this.handleKeyDown,
        style: this._getStyle(style, width)
      }, rest), renderContentWithArrow(Content, content, {
        arrowColor: arrowColor,
        arrowSize: arrowSize,
        placement: placement,
        use: use
      }, onOpenChange, showCloseButton))) : null;
      return _react.default.createElement(_TwoWayTransition.default, {
        onCloseComplete: onCloseComplete,
        onCloseStart: this.handleCloseStart,
        onOpenComplete: this.handleOpenComplete,
        onOpenStart: onOpenStart,
        transitionOnMount: animateOnMount,
        duration: animateOnToggle ? transitionDuration : 0,
        Wrapper: PopoverTransitionWrapper
      }, renderedContent);
    }
  }]);
  return UIPopoverContent;
}(_react.default.Component);

UIPopoverContent.propTypes = {
  animateOnMount: _react.PropTypes.bool.isRequired,
  animateOnToggle: _react.PropTypes.bool,
  arrowColor: _react.PropTypes.string,
  arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)).isRequired,
  content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
    header: _react.PropTypes.node,
    body: _react.PropTypes.node,
    footer: _react.PropTypes.node
  })]),
  Content: _component.default,
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenChange: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  showCloseButton: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};
UIPopoverContent.defaultProps = {
  animateOnMount: false,
  open: false,
  placement: 'top',
  use: 'default'
};
UIPopoverContent.displayName = 'UIPopoverContent';
var _default = UIPopoverContent;
exports.default = _default;
module.exports = exports.default;